"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Row = _interopRequireDefault(require("../../foundational/Layout/Row"));
var _Col = _interopRequireDefault(require("../../foundational/Layout/Col"));
var _Title = _interopRequireDefault(require("../Title"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "thumnailSrc", "videoTitle", "videoDesc"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".VideoList:nth-child(even) .VideoList__thumbnail_container,\n.VideoList:nth-child(even) .VideoList__text {\n  margin-top: 1rem;\n}\n.VideoList__thumbnail_col {\n  padding-left: 0 !important;\n}\n.VideoList__text--title {\n  font-size: 0.875rem;\n  padding-right: 1rem;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  overflow: hidden;\n  word-wrap: break-word;\n}\n.VideoList__text--desc {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  text-decoration: none !important;\n  font-weight: 400;\n  font-size: 0.875rem;\n  color: #424242;\n  line-clamp: 3;\n  overflow: hidden;\n  word-wrap: break-word;\n  line-height: 1.5rem;\n  padding-right: 1rem;\n}\n@media (min-width: 48.1rem) and (max-width: 64rem) {\n  .VideoList__text--desc {\n    display: none;\n  }\n}\n@media (min-width: 64rem) and (max-width: 81.25rem) {\n  .VideoList__text--desc {\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n  }\n}\n@media (max-width: 27rem) {\n  .VideoList__text--desc {\n    display: none;\n  }\n}\n@media (max-width: 40rem) {\n  .VideoList__text {\n    padding-right: 0 !important;\n  }\n  .VideoList__text--desc {\n    line-clamp: 1;\n    -webkit-line-clamp: 1;\n  }\n}\n.VideoList__thumbnail_container {\n  margin-left: 0.25rem;\n  max-height: 9.4rem;\n  overflow: hidden;\n}\n@media (max-width: 78rem) {\n  .VideoList__thumbnail_container {\n    max-height: 7.4rem;\n  }\n}\n@media (max-width: 61rem) {\n  .VideoList__thumbnail_container {\n    max-height: 6rem;\n  }\n}\n@media (max-width: 56rem) {\n  .VideoList__thumbnail_container {\n    max-height: 5.7rem;\n  }\n}\n@media (max-width: 48rem) {\n  .VideoList__thumbnail_container {\n    max-height: 9.4rem;\n  }\n}\n.VideoList__thumbnail_container img {\n  margin-top: -9.5% !important;\n  -webkit-clip-path: polygon(0 13%, 100% 13%, 100% 87%, 0 87%);\n  clip-path: polygon(0 13%, 100% 13%, 100% 87%, 0 87%);\n  -ms-clip-path: polygon(0 13%, 100% 13%, 100% 87%, 0 87%);\n}";
  var fileName = "VideoList_VideoList";
  var element = document.querySelector("style[data-sass-component='VideoList_VideoList']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var VideoList = function VideoList(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$thumnailSrc = _ref.thumnailSrc,
    thumnailSrc = _ref$thumnailSrc === void 0 ? '' : _ref$thumnailSrc,
    _ref$videoTitle = _ref.videoTitle,
    videoTitle = _ref$videoTitle === void 0 ? '' : _ref$videoTitle,
    _ref$videoDesc = _ref.videoDesc,
    videoDesc = _ref$videoDesc === void 0 ? '' : _ref$videoDesc,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var justTitle = videoTitle && videoTitle.replace('| Credit One Bank', '');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Row["default"], _objectSpread(_objectSpread({
    className: "".concat(className, " VideoList")
  }, rest), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Col["default"], {
      xs: 3,
      sm: 2,
      md: 7,
      className: "VideoList__thumbnail_col",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "VideoList__thumbnail_container PT-MD-0",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: thumnailSrc,
          alt: "Thumbnail of ".concat(!justTitle ? videoTitle : justTitle, " video"),
          "aria-hidden": "true"
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Col["default"], {
      xs: 3,
      sm: 4,
      md: 5,
      className: "VideoList__text PT-MD-0",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Title["default"], {
        tag: "h6",
        className: "VideoList__text--title MB-H",
        children: !justTitle ? videoTitle : justTitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "VideoList__text--desc",
        children: videoDesc
      })]
    })]
  }));
};
var _default = VideoList;
exports["default"] = _default;